import React from 'react';
import AiArrowSwitch from '@/public/icons/ai-arrow-switch-horizontal.svg';
import ActionButtonBase from '../ActionButtonBase';

export type WordReplaceButtonProps = {
  onClick?: () => void;
  buttonClassName?: string;
  disabled?: boolean;
};

const WordReplaceButton = ({
  onClick,
  buttonClassName = 'ai_border',
  disabled,
}: WordReplaceButtonProps) => {
  return (
    <ActionButtonBase
      onClick={onClick}
      buttonClassName={buttonClassName}
      disabled={disabled}
      icon={<AiArrowSwitch />}
      label="단어 바꾸기"
    />
  );
};

export default WordReplaceButton;
